import styled from 'styled-components'
import { Text } from '@workwhile/ui'

export const ReadOnlyBox = styled(Text)`
  color: ${({ theme }) => theme.colors.lightText};
  background-color: ${({ theme }) => theme.colors.neutrals[100]};
  padding: ${({ theme }) => theme.space[2]};
  padding-left: ${({ theme }) => theme.space[3]};
  padding-right: ${({ theme }) => theme.space[3]};
  border-radius: ${({ theme }) => theme.radii.standard};
`
